import React, { useEffect, useState } from "react";
import { IAccount } from "../../../../lib/features/accounts/account.constant";
import { Form, Input, Modal } from "antd";
import { useAppDispatch } from "../../../../lib/hook";
import { useForm } from "antd/es/form/Form";
import { IAccountUpdate } from "../../../../models/account";

import { getDetailAccount } from "../../../../apis/account";

import { FormProps } from "antd/lib";
import { onUpdateAccount } from "../../../../lib/features/accounts/accounts.thunk";

interface ModalUpdateAccountProps {
  visible: boolean;
  accountId: string;
  onClose: () => void;
}

const ModalUpdateAccount: React.FC<ModalUpdateAccountProps> = (
  props: ModalUpdateAccountProps
) => {
  const { visible, accountId, onClose } = props;
  const dispatch = useAppDispatch();
  const [account, setAccount] = useState<IAccount | null>(null);
  const [loading, setLoading] = useState(false);
  const [form] = useForm();
  const handleGetDetailAccount = async () => {
    if (!accountId) return;
    setLoading(true);
    try {
      const res = await getDetailAccount(accountId);
      if (res?.data) {
        setAccount(res?.data);
      } else {
        setAccount(null);
      }
    } catch (error) {
      console.error("Error fetching customer detail:", error);
      setAccount(null);
    } finally {
      setLoading(false);
    }
  };
  useEffect(() => {
    if (visible) {
      handleGetDetailAccount();
      return () => {
        form.resetFields();
        setAccount(null);
        setLoading(false);
      };
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [visible]);
  const onFinish: FormProps<IAccountUpdate>["onFinish"] = async (values) => {
    setLoading(true);

    await dispatch(onUpdateAccount({ id: accountId, data: values })).then(
      (result) => {
        if (result?.type.includes("fulfilled")) {
          form.resetFields();
          onClose && onClose();
          setLoading(false);
        }
      }
    );

    setLoading(false);
  };
  return (
    <Modal
      loading={loading}
      title="Cập nhật tài khoản"
      open={visible}
      onCancel={onClose}
      onOk={() => form.submit()}
      confirmLoading={loading}
    >
      <Form
        disabled={loading}
        layout="vertical"
        form={form}
        onFinish={onFinish}
        autoComplete="off"
        className="mt-3"
        initialValues={
          account === null
            ? {}
            : {
                fullName: account?.fullName,

                phone: account?.phone,
                email: account?.email,
              }
        }
      >
        <Form.Item<IAccountUpdate>
          label="Họ và tên"
          name="fullName"
          rules={[{ required: true, message: "Mời điền họ và tên" }]}
          style={{ marginBottom: 8 }}
        >
          <Input placeholder="Nhập tên" />
        </Form.Item>
        <Form.Item<IAccountUpdate>
          label="Số điện thoại "
          name="phone"
          rules={[{ required: true, message: "Mời điền số điện thoại" }]}
          style={{ marginBottom: 8 }}
        >
          <Input placeholder="Nhập số điện thoại" />
        </Form.Item>
        <Form.Item<IAccountUpdate>
          label="Email"
          name="email"
          rules={[{ required: true, message: "Mời điền email" }]}
          style={{ marginBottom: 8 }}
        >
          <Input placeholder="Nhập email" />
        </Form.Item>
      </Form>
    </Modal>
  );
};

export default ModalUpdateAccount;
